// Copyright ©️ 2026 eVolve MEP, LLC

import { SizeField } from './SizeField';

type StrokeWidthFieldProps = { id: string; label: string; value: string };

export const StrokeWidthField = (props: StrokeWidthFieldProps) => <SizeField {...props} />;
